import React from 'react'
import WorkFlowRunsTable from './components/WorkFlowRunsTable'
import { Button, Col, Row } from 'antd';
import { BarChartOutlined, TableOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const WorkflowRunsPage = () => {
  const navigate = useNavigate();
  const handlePage =() => {
    navigate('/tasks/reports/reportsanalytics');
  }
  return (


      <div className="page-heading-library-schedule">
        <Row gutter={[0, 12]}>

          <Col span={24} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h1 className='page-heading-report'>Workflow Runs</h1>
            <Col>
              <Button style={{ marginRight: '10px', border: 'none', background: 'rgba(173,216,230,0.5)', borderRadius: '30px' }}><TableOutlined />Table</Button>
              {/* <Button style={{ border: 'none', background: '#fffa', borderRadius: '30px' }} onClick={handlePage}><BarChartOutlined />Analytics</Button> */}
            </Col>

          </Col>


          <Col span={24} style={{ margin: '20px 0px' }}>
            <WorkFlowRunsTable />
          </Col>


        </Row>
      </div>
  
  )
}

export default WorkflowRunsPage;


